'use client';

import { c as _c } from "react/compiler-runtime";
import AutoRedirect from './AutoRedirect';
import authClient from '@/api/auth/client';
import { useRouter } from 'next/navigation';
import { AUTH_PATHS, AuthError } from '@repo/api/auth/constants';
import * as R from 'remeda';
import SignInPage from '@repo/ui/pages/auth/SignInPage';
export default function DashboardSignInPage(t0) {
  const $ = _c(12);
  const {
    searchParams
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.then(_temp);
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const callbackUrlPromise = t1;
  let t2;
  let t3;
  if ($[2] !== router) {
    t2 = url => {
      router.push(url);
    };
    t3 = error => {
      if (R.isIncludedIn(error, AuthError.options)) {
        router.push(`${AUTH_PATHS.ERROR}?error=${error}`);
        throw new Error(`Authentication failed: ${error}`);
      } else {
        console.warn("Auth error", error);
      }
    };
    $[2] = router;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== callbackUrlPromise || $[6] !== t2 || $[7] !== t3) {
    t4 = <SignInPage authClient={authClient} callbackUrl={callbackUrlPromise} errorCallbackUrl={AUTH_PATHS.ERROR} onRedirect={t2} onError={t3} />;
    $[5] = callbackUrlPromise;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <AutoRedirect />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <>{t4}{t5}</>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp(params) {
  return R.isString(params.callbackUrl) ? params.callbackUrl : "/";
}